const { NOTIFICATIONS_TYPE } = require('../../constants/notificationsConstants')
const { jobStatusType } = require('../../js/constants')
let billingStatusStates = require('cloud-utils/config/device-billing-status-states/billingStatus.json')
billingStatusStates = JSON.parse(JSON.stringify(billingStatusStates))
billingStatusStates.billingStatusNotSet = {
  name: 'billingStatusNotSet',
  value: null,
  translationKey: 'BillingStatusNotSet',
  valueInEs: 'NA',
  title: 'Billing Status Not Set'
}

angular
  .module('surfsightApp.controllers')
  .controller('healthReportsHealthController', [
    '$scope',
    '$rootScope',
    '$state',
    '$stateParams',
    '$timeout',
    '$interval',
    '$location',
    '$window',
    '$http',
    '$filter',
    '$localStorage',
    '$mdDialog',
    '$mdSidenav',
    '$mdToast',
    '$mdColors',
    '$mdMedia',
    'edgeFactory',
    'edgeGroupFactory',
    'broadcastViewFactory',
    'leafletData',
    'leafletBoundsHelpers',
    'SystemConstants',
    'UnitSystem',
    'NgTableParams',
    '$q',
    function (
      $scope,
      $rootScope,
      $state,
      $stateParams,
      $timeout,
      $interval,
      $location,
      $window,
      $http,
      $filter,
      $localStorage,
      $mdDialog,
      $mdSidenav,
      $mdToast,
      $mdColors,
      $mdMedia,
      edgeFactory,
      edgeGroupFactory,
      broadcastViewFactory,
      leafletData,
      leafletBoundsHelpers,
      SystemConstants,
      UnitSystem,
      NgTableParams,
      $q
    ) {
      $scope.billingStatusStates = billingStatusStates
      $scope.userOrganization = $localStorage.userOrganization
      let tableApiRequestTimeout = null
      let lastRequestQueryParams = null
      const initialPageSize = 100
      $scope.data = {}
      $scope.data.gridOptions = {
        data: [],
        sort: {
          predicate: 'last_connected_at',
          direction: 'desc'
        },
        urlSync: true,
        defaultPageSize: initialPageSize,
        pagination: {
          itemsPerPage: initialPageSize
        },
        getData: (params, callback) => {
          tableApiRequestTimeout && tableApiRequestTimeout.resolve()
          const urlSearchParams = new URLSearchParams(params)
          const queryParamsIterator = urlSearchParams.entries()
          const requestQueryParams = new URLSearchParams('')
          requestQueryParams.set(
            'organizationId',
            $localStorage.userOrganization.id
          )
          requestQueryParams.set(
            'limit',
            urlSearchParams.get('itemsPerPage') ||
              $scope.data.gridOptions.defaultPageSize
          )
          for (const queryParam of queryParamsIterator) {
            const [key, value] = queryParam
            if (key === 'page') {
              requestQueryParams.set('page', value)
            } else if (key === 'sort') {
              const lastIndex = value.lastIndexOf('-')
              requestQueryParams.set('sort', value.substr(0, lastIndex))
              requestQueryParams.set(
                'order',
                value.substr(lastIndex + 1) === 'desc' ? 0 : 1
              )
            } else if (value !== 'select') {
              requestQueryParams.set(key.replace(/grid_search\./, ''), value)
            }
          }
          if (!requestQueryParams.get('sort')) {
            requestQueryParams.set('sort', 'createdAt')
            requestQueryParams.set('order', 'desc')
          }
          tableApiRequestTimeout = $q.defer()
          lastRequestQueryParams = requestQueryParams
          const requestJson = {
            method: 'GET',
            url: `${DEVICE_BASEURL}/device-health?${requestQueryParams.toString()}`,
            timeout: tableApiRequestTimeout
          }
          const fourHoursAgo = moment.utc().subtract(4, 'hours')
          const eightHoursAgo = moment.utc().subtract(8, 'hours')
          const twelveHoursAgo = moment.utc().subtract(12, 'hours')
          const oneDayAgo = moment.utc().subtract(1, 'days')
          $http(requestJson)
            .then(async ({ data }) => {
              const devices = data.devices.map(device => {
                if (
                  moment.utc(device.last_connected_at).isSameOrBefore(oneDayAgo)
                ) {
                  device.lastConnectedAtColor = 'red'
                  device.lastConnectedAtIndicator = 24
                } else if (
                  moment
                    .utc(device.last_connected_at)
                    .isSameOrBefore(twelveHoursAgo)
                ) {
                  device.lastConnectedAtColor = 'red'
                  device.lastConnectedAtIndicator = 12
                } else if (
                  moment
                    .utc(device.last_connected_at)
                    .isSameOrBefore(eightHoursAgo)
                ) {
                  device.lastConnectedAtColor = 'orange'
                  device.lastConnectedAtIndicator = 8
                } else if (
                  moment
                    .utc(device.last_connected_at)
                    .isSameOrBefore(fourHoursAgo)
                ) {
                  device.lastConnectedAtColor = 'orange'
                  device.lastConnectedAtIndicator = 4
                }
                if (device.last_connected_at) {
                  device.last_connected_at =
                    device.last_connected_at &&
                    new Date(device.last_connected_at).toString()
                }
                if (device.lastRecordingAt) {
                  device.lastRecordingAt =
                    device.lastRecordingAt &&
                    new Date(device.lastRecordingAt).toString()
                }
                if (device.lastRecordingUpdatedAt) {
                  device.lastRecordingUpdatedAt =
                    device.lastRecordingUpdatedAt &&
                    new Date(device.lastRecordingUpdatedAt).toString()
                }
                availableDateFields.forEach(dateField => {
                  if (device[dateField]) {
                    const date = moment(device[dateField])
                    if (
                      dateField === 'lastRecordingUpdatedAt' ||
                      dateField === 'last_connected_at'
                    ) {
                      device[dateField] = date.utc().format('lll')
                    } else {
                      device[dateField] =
                        moment().diff(date) < 24 * 60 * 60 * 1000
                          ? date.fromNow()
                          : date.format('lll')
                    }
                  } else {
                    device[dateField] = '--'
                  }
                })
                emptyValueReplaceColumns.forEach(field => {
                  device[field] = device[field] || '--'
                })
                return device
              })
              callback(devices, data.totalCount)
            })
            .catch(handleServerError)
        }
      }
      $scope.tableRefresh = function () {
        $scope.$broadcast('$locationChangeSuccess', '')
      }
      $timeout(() => {
        $scope.tableRefresh()
      })
      const tableRefreshInterval = $interval(() => {
        $scope.tableRefresh()
      }, 60 * 1000)
      const availableDateFields = [
        'last_connected_at',
        'lastRecordingUpdatedAt',
        'lastRecordingAt'
      ]
      const emptyValueReplaceColumns = [
        'edgeName',
        'organizationName',
        'resellerName',
        'last_connected_at',
        'lastRecordingUpdatedAt',
        'lastRecordingAt'
      ]
      $scope.grid_search = {}
      availableDateFields.forEach(e => {
        $scope.grid_search[e] = {}
      })
      const handleServerError = error => {
        $scope.$emit('handleServerError', error)
      }
      $scope.changeDateFormat = date => moment(date).format('MMM D YYYY')
      $scope.resetCurrentReportDownload = () => {
        $scope.downloadStatus = {
          downloadRequestStatus: jobStatusType.INITIAL
        }
      }
      $scope.resetCurrentReportDownload()
      $scope.downloadCurrentReport = () => {
        const requestTimeout = $q.defer()
        $scope.downloadStatus.downloadRequestStatus = jobStatusType.IN_QUEUE
        try {
          const queryParams = new URLSearchParams(lastRequestQueryParams)
          ;['page', 'limit', 'sort', 'order'].forEach(param => {
            queryParams.delete(param)
          })
          const requestJson = {
            method: 'GET',
            url:
              DEVICE_BASEURL +
              '/device-health-download?' +
              queryParams.toString(),
            timeout: requestTimeout
          }
          $http(requestJson)
            .then(res => {
              $scope.downloadStatus.downloadRequestStatus =
                jobStatusType.COMPLETED
              $scope.$emit('reportDownloadRequested', {
                reportType:
                  NOTIFICATIONS_TYPE.downloadDevicesHealthReport
                    .notificationType
              })
            })
            .catch(error => {
              console.error('Error getting report:', error)
              $scope.downloadStatus.downloadRequestStatus = jobStatusType.FAILED
            })
        } catch (ex) {
          console.error(ex)
          showMessageToast(ex.message)
        }
      }
      $scope.showAlarmRecipients = ev => {
        $mdDialog
          .show({
            controller: 'healthReportsHealthNotificationsController',
            templateUrl:
              './templates/health-reports/health-reports-health-notifications.view.html?t=' +
              window.webpackHash,
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: false,
            fullscreen: false // Only for -xs, -sm breakpoints.
          })
          .then(() => {})
          .catch(() => {})
      }
      $scope.$on('$destroy', () => {
        $interval.cancel(tableRefreshInterval)
      })
    }
  ])
